{
  "metadata": {
    "id": "nord-light",
    "name": "Nord",
    "description": "Портировано из темы «Nord» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "nord.json",
      "project": "nordtheme",
      "url": "https://github.com/nordtheme/nord",
      "upstreamFile": "packages/ui/src/theme/themes/nord.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 23.3,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.318,
      "paletteMaxS": 0.384,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.4,
      "syntaxVsTextMinDeltaE": 11.1,
      "chartsMinDeltaE": 22.4,
      "textSeparationDeltaE": 10.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "keyword",
          "deltaE": 17.8
        },
        {
          "a": "comment",
          "b": "function",
          "deltaE": 17.8
        },
        {
          "a": "keyword",
          "b": "function",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#5e81ac",
      "hover": "#55749b",
      "active": "#4d6a8d",
      "foreground": "#000000",
      "muted": "#5e81ac80",
      "emphasis": "#5e81ac"
    },
    "surface": {
      "background": "#eceff4",
      "foreground": "#262b35",
      "muted": "#bdc1c8",
      "mutedForeground": "#3d4046",
      "elevated": "#a7abb3",
      "elevatedForeground": "#2e3440",
      "raised": "#8b9099",
      "raisedForeground": "#232831",
      "overlay": "#eceff433",
      "subtle": "#d5d8df"
    },
    "interactive": {
      "border": "#858a94",
      "borderHover": "#b7bbc2",
      "borderFocus": "#5e81ac",
      "selection": "#2e344024",
      "selectionForeground": "#2e3440",
      "focus": "#5e81ac59",
      "focusRing": "#5e81ac47",
      "cursor": "#2e3440",
      "hover": "#2e344017",
      "active": "#2e344024"
    },
    "status": {
      "error": "#b44953",
      "errorForeground": "#ffffff",
      "errorBackground": "#b449531a",
      "errorBorder": "#b4495359",
      "warning": "#a85237",
      "warningForeground": "#ffffff",
      "warningBackground": "#a852371a",
      "warningBorder": "#a8523759",
      "success": "#457372",
      "successForeground": "#ffffff",
      "successBackground": "#4573721a",
      "successBorder": "#45737259",
      "info": "#496e93",
      "infoForeground": "#ffffff",
      "infoBackground": "#496e931a",
      "infoBorder": "#496e9359"
    },
    "pr": {
      "open": "#457372",
      "draft": "#4c4f56",
      "blocked": "#a85237",
      "merged": "#bf616a",
      "closed": "#b44953"
    },
    "syntax": {
      "base": {
        "background": "#bdc1c8",
        "foreground": "#2e3440",
        "comment": "#484d58",
        "keyword": "#384f6c",
        "string": "#445336",
        "number": "#63415d",
        "function": "#384f6c",
        "variable": "#2e3440",
        "type": "#660e85",
        "operator": "#0c0d0e"
      },
      "tokens": {
        "commentDoc": "#484d58",
        "stringEscape": "#0c0d0e",
        "keywordImport": "#384f6c",
        "storageModifier": "#384f6c",
        "functionCall": "#384f6c",
        "method": "#384f6c",
        "variableProperty": "#384f6c",
        "variableOther": "#2e3440",
        "variableGlobal": "#63415d",
        "variableLocal": "#0c0d0e",
        "parameter": "#2e3440",
        "constant": "#63415d",
        "class": "#660e85",
        "className": "#660e85",
        "interface": "#660e85",
        "struct": "#660e85",
        "enum": "#660e85",
        "typeParameter": "#660e85",
        "namespace": "#660e85",
        "module": "#384f6c",
        "tag": "#384f6c",
        "jsxTag": "#384f6c",
        "tagAttribute": "#384f6c",
        "tagAttributeValue": "#445336",
        "boolean": "#63415d",
        "decorator": "#384f6c",
        "label": "#384f6c",
        "regexp": "#445336"
      }
    },
    "charts": {
      "series": [
        "#5e81ac",
        "#495593",
        "#457372",
        "#a85237",
        "#b38273"
      ]
    },
    "chat": {
      "background": "#eceff4",
      "userMessage": "#2e3440",
      "userMessageBackground": "#a7abb3",
      "assistantMessage": "#2e3440",
      "assistantMessageBackground": "#bdc1c8",
      "timestamp": "#4c4f56",
      "divider": "#858a94",
      "typing": "#4c4f56"
    },
    "loading": {
      "spinner": "#5e81ac",
      "spinnerTrack": "#bdc1c8",
      "skeleton": "#bdc1c8",
      "shimmer": "#b4b9c0"
    },
    "tools": {
      "background": "#bdc1c8",
      "border": "#858a94",
      "headerHover": "#b6bac1",
      "icon": "#4b6a91",
      "title": "#2e3440",
      "description": "#4c4f56",
      "edit": {
        "added": "#457372",
        "addedBackground": "#4573721a",
        "removed": "#b44953",
        "removedBackground": "#b449531a",
        "modified": "#496e93",
        "modifiedBackground": "#496e931a",
        "lineNumber": "#4c4f56"
      }
    },
    "markdown": {
      "heading1": "#2e3440",
      "heading2": "#2e3440",
      "heading3": "#2e3440",
      "heading4": "#2e3440",
      "link": "#4d6d95",
      "linkHover": "#506d91",
      "inlineCode": "#445336",
      "inlineCodeBackground": "#bdc1c8",
      "blockquote": "#4c4f56",
      "blockquoteBorder": "#858a94",
      "listMarker": "#5b7eaa",
      "bold": "#2e3440",
      "italic": "#2e3440e6",
      "strikethrough": "#4c4f56",
      "hr": "#858a94"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#9f4c59",
        "foreground": "#ffffff",
        "contrast": 5.75
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#785c4b",
        "foreground": "#ffffff",
        "contrast": 6.12
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cfc197",
        "foreground": "#000000",
        "contrast": 11.73
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#7f804c",
        "foreground": "#000000",
        "contrast": 5.09
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#a4bf75",
        "foreground": "#000000",
        "contrast": 10.29
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#54a452",
        "foreground": "#000000",
        "contrast": 6.81
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#97cfae",
        "foreground": "#000000",
        "contrast": 11.85
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#4e7966",
        "foreground": "#ffffff",
        "contrast": 4.94
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#74b3bd",
        "foreground": "#000000",
        "contrast": 8.93
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#406984",
        "foreground": "#ffffff",
        "contrast": 5.88
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#6b7ab7",
        "foreground": "#000000",
        "contrast": 5.09
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#45499b",
        "foreground": "#ffffff",
        "contrast": 7.84
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#654a76",
        "foreground": "#ffffff",
        "contrast": 7.51
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c293cb",
        "foreground": "#000000",
        "contrast": 8.33
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#a04d91",
        "foreground": "#ffffff",
        "contrast": 5.3
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c29da7",
        "foreground": "#000000",
        "contrast": 8.67
      }
    ]
  }
}
